// removed by extract-text-webpack-plugin
module.exports = {"this":"MarketingLayout__this___10puQ","headerContainer":"MarketingLayout__headerContainer___3P382","content":"MarketingLayout__content___1xFew","header":"MarketingLayout__header___33upT","headerBorder":"MarketingLayout__headerBorder___3JO1C","container":"MarketingLayout__container___glpqw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/MarketingLayout.css
// module id = 2673
// module chunks = 0 1